import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChatReply } from '../api/AssistantApi';
import DailySalesChart from './DailySalesChart';

export default function AssistantSources({ sources }: { sources: NonNullable<ChatReply['sources']> }) {
  const { t } = useTranslation();
  return <>{sources.map((source, index) => <React.Fragment key={index}>
    {source.tool === 'getDailySales' && <DailySalesChart data={source.data} />}
    <details className="assistant-result assistant-source">
    <summary>{t('chat.sourceLabel')}: {t(`chat.tools.${source.tool}`, { defaultValue: source.tool })}</summary>
    {source.data.items.length ? <div className="assistant-table-scroll"><table>
      <caption className="assistant-sr-only">{t('chat.liveResults')}</caption>
      <thead><tr>{Object.keys(source.data.items[0]).map(key => <th key={key} scope="col">{t(`chat.fields.${key}`, { defaultValue: key })}</th>)}</tr></thead>
      <tbody>{source.data.items.map((row, rowIndex) => <tr key={rowIndex}>{Object.keys(source.data.items[0]).map(key => <td key={key}>{row[key] ?? '—'}</td>)}</tr>)}</tbody>
    </table></div> : <p>{t('chat.noResults')}</p>}
    <p className="assistant-coverage">{source.data.coverage}</p>
    {source.data.hasMore && <p className="assistant-coverage">{t('chat.sourceLimited')}</p>}
  </details></React.Fragment>)}</>;
}
